let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2lsX7")).then(() => parcelRequire('5zTqW'));